import React from "react";
import {
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Grid,
  TextField,
  Alert,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { EventContext } from "../../../contexts/EventContext";
import axios from "axios";
// import ProfileTextField from "./components/ProfileTextField";
// import ProfileSelectField from "./components/ProfileSelectField";

import request from "../../../utilities/requests";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditAdDialog = ({ open, close, ad, advertiser }) => {
  const { userData } = React.useContext(EventContext);
  const [data, setData] = React.useState({});
  const [error, setError] = React.useState(null);
  const [events, setEvents] = React.useState([]);
  const [selectedEvents, setSelectedEvents] = React.useState([]);
  const [showConfirm, setShowConfirm] = React.useState(false);
  const inputFile = React.useRef(null);

  React.useEffect(() => {
    if (ad) {
      setData(ad);
    }
  }, [ad]);

  React.useEffect(() => {
    if (ad?.events) {
      setSelectedEvents(ad.events);
    }
  }, [events]);

  React.useEffect(() => {
    if (open) getEvents();
  }, [open]);

  const getEvents = async () => {
    const result = await request("pairingevent");

    if (result.success) {
      const eData = result.pairingEvents.filter(
        (ev) => ev?.event?.org === advertiser?.org
      );
      setEvents(eData);
    }
  };

  const renderShow = () => {
    if (data?.trigger) {
      return (
        <Grid item>
          <FormLabel component="legend">When to Show</FormLabel>
          <FormGroup>
            {Object.keys(data.trigger).map((field) => {
              return (
                <FormControlLabel
                  key={field}
                  control={<Checkbox checked={data.trigger[field]} />}
                  onChange={() => handleShowCheck(field)}
                  label={convertLabel(field)}
                />
              );
            })}
          </FormGroup>
        </Grid>
      );
    }
    return <></>;
  };

  const convertLabel = (field) => {
    const result = field.replace(/([A-Z])/g, " $1");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
  };

  const formatDate = (date) => {
    if (date) {
      return date.split("T")[0]
    }
    return ""
  }

  const handleShowCheck = (field) => {
    let d = data;
    d.trigger[field] = !d.trigger[field];
    setData({ ...d });
  };

  const handleUpload = async (event) => {
    const file = event.target.files[0];
    const body = new FormData();
    body.append("photo", file);
    body.append("Content-Type", "image/jpg");
    body.append("adId", ad._id);
    const token = localStorage.getItem(`${process.env.REACT_APP_COGNITO_CLIENT_ID}.accessToken`);
    // setLoading(true);
    axios({
      url: `${process.env.REACT_APP_TNFT_SERVER}/ads/ad/uploadimage`,
      method: "post",
      data: body,
      headers: { "Content-Type": "multipart/form-data", Accesstoken: token },
    })
      .then((response) => {
        if (response?.data?.success) {
          setData({ ...data, imageUrl: response?.data?.imageUrl });
          return;
        }
      })
      .catch((response) => {
        console.error(response);
        // setLoading(false);
      });
  };

  const renderImage = () => {
    if (data?.imageUrl) {
      return <img src={data.imageUrl} style={{ height: 200 }} />;
    }
    return <></>;
  };

  const renderStyle = () => {
    if (data?.style) {
      return Object.keys(data.style).map((field) => {
        return (
          <Grid item key={field}>
            <TextField
              fullWidth
              label={convertLabel(field)}
              value={data?.style[field] ? data.style[field] : ""}
              onChange={(e) => handleEditStyle(field, e.target.value)}
            />
          </Grid>
        );
      });
    }
    return <></>;
  };

  const handleEditStyle = (field, value) => {
    let d = data;
    d.style[field] = value;
    setData({ ...d });
  };

  const handleSave = async () => {
    let body;
    let result;

    if (ad) {
      let update = {};
      if (data.name !== ad.name) {
        update.name = data.name;
      }
      if (data.active !== ad.active) {
        update.active = data.active;
      }
      if (data.adType !== ad.adType) {
        update.adType = data.adType;
      }
      if (data.finalUrl !== ad.finalUrl) {
        update.finalUrl = data.finalUrl;
      }
      if (data.displayTime !== ad.displayTime) {
        update.displayTime = data.displayTime;
      }
      if (data.autoClose !== ad.autoClose) {
        update.autoClose = data.autoClose;
      }
      update.events = selectedEvents;
      update.trigger = data.trigger;
      update.style = data.style;
      body = {
        adId: ad._id,
        update,
      };
      result = await request("ads/ad/update", "post", body);
      if (!result.success) {
        setError(result.error);
        return;
      }
      handleClose();
      return;
    }

    if (!data.name) {
      setError("Enter an Ad name");
      return;
    }
    body = {
      orgId: advertiser.org,
      advertiserId: advertiser._id,
      name: data.name,
      active: data.active ? data.active : false,
      events: selectedEvents,
      adType: data.adType,
    };
    result = await request("ads/ad/create", "post", body);
    if (!result.success) {
      setError(result.error);
      return;
    }

    handleClose();
    return;
  };

  const handleClose = () => {
    setError(null);
    setData({});
    setSelectedEvents([]);
    close();
  };

  const handleDelete = async () => {
    setShowConfirm(false);
    const body = { adId: ad._id };
    const result = await request("ads/ad/delete", "post", body);
    if (result.success) {
      alert("Ad deleted successfully");
      handleClose();
      return;
    } else {
      setError(result.error);
    }
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {ad ? "Edit Ad" : "New Ad"}
          </Typography>
          <Button autoFocus color="inherit" onClick={handleSave}>
            save
          </Button>
        </Toolbar>
      </AppBar>
      <Grid container direction="column" spacing={3} style={{ padding: 20 }}>
        {error ? (
          <Grid item>
            <Alert severity="error">{error}</Alert>
          </Grid>
        ) : (
          <></>
        )}

        <Grid item>
          <TextField
            fullWidth
            label="Advertiser"
            value={advertiser?.name ? advertiser.name : ""}
            disabled
          />
        </Grid>
        <Grid item>
          <TextField
            fullWidth
            label="Ad Name"
            value={data?.name ? data.name : ""}
            onChange={(e) => setData({ ...data, name: e.target.value })}
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            control={<Checkbox checked={data?.active ? data.active : false} />}
            onChange={() => setData({ ...data, active: !data.active })}
            label="Active"
          />
        </Grid>
        <Grid item>
          <FormControl fullWidth>
            <InputLabel>Select Events</InputLabel>
            <Select
              value={selectedEvents}
              label="Select Events"
              autoWidth
              multiple
              onChange={(e) => setSelectedEvents(e.target.value)}
            >
              {events.map((event) => {
                return (
                  <MenuItem key={event._id} value={event?.event?._id}>
                   {formatDate(event?.event?.date)} | {event?.event?.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl fullWidth>
            <InputLabel>Ad Type</InputLabel>
            <Select
              value={data?.adType ? data?.adType : ""}
              autoWidth
              label="Ad Type"
              onChange={(e) => setData({ ...data, adType: e.target.value })}
            >
              <MenuItem value="fullScreen">Full Screen</MenuItem>
              <MenuItem value="popUp">Pop Up</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <TextField
            fullWidth
            label="Final URL"
            value={data?.finalUrl ? data.finalUrl : ""}
            onChange={(e) => setData({ ...data, finalUrl: e.target.value })}
          />
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        <Grid item>
          <Grid
            container
            direction="column"
            spacing={2}
            style={{ paddingLeft: 20 }}
          >
            <Grid item>
              <Typography style={{ fontWeight: "bold" }}>Ad Image</Typography>
            </Grid>
            <Grid item>{renderImage()}</Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => inputFile.current.click()}
              >
                {data?.imageUrl ? "Change image" : "Upload image"}
              </Button>
              <input
                type="file"
                ref={inputFile}
                onChange={handleUpload}
                style={{ display: "none" }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        {renderShow()}
        <Grid item>
        <TextField
            fullWidth
            label="Display Time (seconds)"
            value={data?.displayTime ? data.displayTime : ""}
            onChange={(e) => setData({ ...data, displayTime: e.target.value })}
          />
        </Grid>
        <Grid item>
        <Grid item>
          <FormControlLabel
            control={<Checkbox checked={data?.autoClose ? data.autoClose : false} />}
            onChange={() => setData({ ...data, autoClose: !data.autoClose })}
            label="Auto Close"
          />
        </Grid>
          <Divider />
        </Grid>
        <Grid item>
          <Typography style={{ fontWeight: "bold" }}>Style</Typography>
        </Grid>
        {renderStyle()}
        <Grid item>
          <Button
            variant="outlined"
            onClick={handleSave}
            style={{ width: "100%" }}
          >
            Save
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            onClick={() => setShowConfirm(true)}
            style={{ width: "100%" }}
            color="secondary"
          >
            Delete
          </Button>
          <Dialog open={showConfirm} onClose={() => setShowConfirm(false)}>
            <DialogTitle id="alert-dialog-title">
              {"Confirm Delete"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete this ad?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowConfirm(false)}>Cancel</Button>
              <Button onClick={handleDelete} autoFocus>
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default EditAdDialog;
